const defaultLimit = 10;

export const productsLimit = defaultLimit;

export const lessonsLimit = 20;

export const packagesLimit = 20;

export const artistsLimit = 20;
